export function getFlagEmoji(countryCode) {
    countryCode = countryCode.replace("en", "gb")
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char =>  127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}